<template>
  <div class="help-right">
    <div class="left"></div>
    <div class="mid">
      <a id="event_1"></a>
      <div class="content">
        <div class="section-wrap">
          <h1>
            <a id="event_2" href="#标题一" class="header-anchor">#</a>
            <span>{{ rightnavs }}</span>
          </h1>
        </div>
        <Guide-content :list="guidePrimaryList" />
        <el-divider
          class="sec-divide"
          v-if="guideSecondList.length"
        ></el-divider>
        <Guide-content :list="guideSecondList" />
      </div>
    </div>

    <!-- 右侧菜单导航 -->
    <div class="navs">
      <span @click="toTop">{{ rightnavs }}</span>
      <ul class="drop">
        <li
          :class="{ active: active === index }"
          v-for="(item, index) in rightToolList"
          :key="index"
          @click="onScrollTop(item, index)"
        >
          <a href="javascript:;">{{ item.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import BlocklyDom from '@/components/common/Blockly.vue'
import GuideContent from '@/components/guide/GuideContent.vue'

export default {
  name: 'GuideDocumentPage',
  props: {
    currentGuide: {
      type: Object,
      default() {
        return {}
      },
    },
    hashId: {
      type: String,
      default: '',
    },
  },
  components: { GuideContent },
  data() {
    return {
      hashIdState: false, // true为积木跳转过来的状态
      intervalNum: 0,
      intervalSum: 5,
      active: 0, // 当前激活的导航索引
      scrollTop: 0,
      rightnavs: '',
      guidePrimaryList: [],
      guideSecondList: [],
    }
  },
  watch: {
    // 监听模块数据列表
    currentGuide: {
      handler(val) {
        // 切换积木模块滚动条置顶
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        if (val && val['primaryGuide']) {
          this.guidePrimaryList = JSON.parse(
            JSON.stringify(val['primaryGuide'])
          )
          this.rightnavs = this.guidePrimaryList[0].rightnavs
        }
        if (val && val['secondGuide'] && val['secondGuide'].length) {
          this.guideSecondList = JSON.parse(JSON.stringify(val['secondGuide']))
        } else {
          this.guideSecondList = []
        }
      },
      deep: true,
      immediate: true,
    },
    hashId: {
      handler(value) {
        if (value) {
          this.$nextTick(() => {
            this.onScrollTop(value)
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    rightToolList() {
      let { guidePrimaryList, guideSecondList } = this
      let list = guidePrimaryList.filter((item) => 'title' in item)
        return list.concat(guideSecondList)
      // if (guideSecondList.length) {
      // } else {
      //   return list
      // }
    },
  },
  created() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll, false)
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    // window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    // 滚动监听器
    onScroll() {
      // 获取所有锚点元素
      let navContents = document.querySelectorAll('.level1 a')
      // 所有锚点元素的 offsetTop
      let offsetTopArr = []
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop)
      })

      // 获取当前文档流的 scrollTop
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      // 定义当前点亮的导航下标
      let navIndex = 0

      for (let n = 0; n < offsetTopArr.length; n++) {
        if (scrollTop + 200 >= offsetTopArr[n]) {
          navIndex = n
        }
      }
      // console.log('navIndex', navIndex)
      this.active = navIndex

      //去掉内存空间
      navContents = null
      offsetTopArr = null
    },

    // 跳转到指定索引的元素
    onScrollTop(data, index) {
      let hashId
      if (typeof data == 'object') {
        hashId = data.id
      } else {
        hashId = data
      }
      // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
      let target = document.querySelector(`#${hashId}`)
      // this.active = index
      //intervalNum--循环遍历次数
      if (!target && this.intervalNum < this.intervalSum) {
        this.intervalNum += 1
        setTimeout(() => {
          this.onScrollTop(this.hashId)
        }, 500)
        return
      } else if (!target) {
        return
      }
      this.intervalNum = 0

      const targetOffsetTop = target.offsetTop - 10

      // 获取当前 offsetTop
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉
      const STEP = 50

      // 判断是往下滑还是往上滑
      if (scrollTop + 160 > targetOffsetTop) {
        // 往上滑
        smoothUp()
      } else {
        // 往下滑
        smoothDown()
      }
      // 定义往下滑函数
      function smoothDown() {
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
        if (scrollTop < targetOffsetTop) {
          // 如果和目标相差距离大于等于 STEP 就跳 STEP
          // 否则直接跳到目标点，目标是为了防止跳过了。
          if (targetOffsetTop - scrollTop >= STEP) {
            scrollTop += STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop - 100
          document.documentElement.scrollTop = scrollTop - 100
          // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
          requestAnimationFrame(smoothDown)
        }
      }
      // 定义往上滑函数
      function smoothUp() {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop - 100
          document.documentElement.scrollTop = scrollTop - 100
          requestAnimationFrame(smoothUp)
        }
      }
    },
    toTop() {
      if (document.documentElement.scrollTop) {
        document.documentElement.scrollTop = 0
      } else {
        document.body.scrollTop = 0
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.help {
  &-left {
    position: fixed;
    width: 220px;
    height: 100%;
    margin-right: 10px;
    background: #fff;

    .title {
      line-height: 60px;
      font-size: 16px;
      color: #333;
      text-align: center;
    }
    .item {
      border-left: 3px solid transparent;
      text-indent: 17px;
      font-size: 14px;
      color: #333;
      line-height: 40px;
      cursor: pointer;
      &:hover,
      &.active {
        border-left: 3px solid #4c88ff;
        background: #dfeaff;
      }
    }
  }
  &-right {
    float: right;
    // width: 970px;
    width: calc(100% - 230px);
    min-height: 780px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.05);
    .left,
    .right,
    .mid {
      float: left;
      width: 14%;
      min-height: 20px;
    }
    .mid {
      width: 72%;
    }

    h1 {
      font-size: 2.2rem;
    }
    h2 {
      font-size: 1.65rem;
      padding-bottom: 0.3rem;
      border-bottom: 1px solid #eaecef;
    }
    p,
    ul {
      line-height: 1.7;
    }
    ul {
      padding-left: 1.2em;
    }
    strong {
      font-weight: 600;
    }
    .content pre,
    .content pre[class*='language-'] {
      background-color: #282c34;
      line-height: 1.4;
      border-radius: 6px;
      padding: 1.25rem 1.5rem;
      margin: 0.85rem 0;
      white-space: pre-wrap;
      word-break: break-word;
      overflow: auto;
      position: relative;
    }
    .content pre:before,
    .content pre[class*='language-']:before {
      position: absolute;
      top: 0.8em;
      right: 1em;
      font-size: 0.75rem;
      color: hsla(0, 0%, 100%, 0.4);
    }
    .content code {
      color: #476582;
      padding: 0.25rem 0.5rem;
      margin: 0;
      font-size: 0.85em;
      background-color: rgba(27, 31, 35, 0.05);
      border-radius: 3px;
    }
    .content pre[class*='language-'] code,
    .content pre code {
      color: #fff;
      padding: 0;
      background-color: transparent;
      border-radius: 0;
    }
    .token.comment,
    .token.doctype,
    .token.prolog {
      color: #999;
    }

    a.header-anchor {
      font-size: 0.85em;
      float: left;
      margin-left: -0.87em;
      padding-right: 0.23em;
      margin-top: 0.125em;
      opacity: 0;
    }
    .content:not(.custom) > h1,
    .content:not(.custom) > h2,
    .content:not(.custom) > h3,
    .content:not(.custom) > h4,
    .content:not(.custom) > h5,
    .content:not(.custom) > h6 {
      margin-top: -3.1rem;
      padding-top: 4.6rem;
      margin-bottom: 0;
    }
    p {
      margin: 1em 0;
    }
    ul {
      list-style-type: disc;
    }
    .toc-box,
    .toc-scroll-mask {
      bottom: 180px;
      position: fixed;
      right: 3.57%;
    }
    .table-of-contents.active {
      display: block;
      width: 200px;
    }
    .table-of-contents.active > ul {
      position: relative;
      margin-top: 0;
      padding-left: 0;
    }
    .table-of-contents.active > ul > li {
      position: relative;
    }
    .table-of-contents li {
      list-style: none;
    }
    .table-of-contents.active > ul > li:before {
      left: 15px;
      top: 14px;
      content: '';
      position: absolute;
      width: 1px;
      height: 100%;
      background-color: #eaecef;
    }
    .table-of-contents.active > ul > li > a {
      font-size: 16px;
      margin-left: 32px;
      color: #333;
    }
    .table-of-contents.active > ul > li > ul {
      position: relative;
      max-height: 300px;
      padding-left: 32px;
    }
    .table-of-contents.active > ul > li > ul > li {
      position: relative;
      white-space: nowrap;
    }
    .table-of-contents > ul > li > ul > li.active a {
      // color: $bgc_btn_primary;
      color: $bgc_btn_primary;
    }
    .table-of-contents.active > ul > li > ul > li:after {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      // background-color: $bgc_btn_primary;
      background: $bgc_btn_primary;
      left: -21px;
      top: 50%;
      margin-top: -2px;
      display: none;
    }
    .table-of-contents.active > ul > li.active:after,
    .table-of-contents.active > ul > li > ul > li.active:after {
      display: block;
    }
    .table-of-contents.active > ul:before {
      left: 9px;
      top: 12px;
    }
    .table-of-contents.active a {
      font-size: 14px;
      color: #666;
    }
    .table-of-contents.active > ul:after,
    .table-of-contents.active > ul:before {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      border: 2px solid #eaecef;
      background-color: #fff;
      z-index: 10;
    }
    .table-of-contents.active > ul:after {
      left: 9px;
      top: 100%;
      margin-top: 5px;
    }
    code,
    kbd {
      font-family: source-code-pro, Menlo, Monaco, Consolas, Courier New,
        monospace;
    }
    ul ul {
      list-style-type: circle;
      margin-block-start: 0px;
      margin-block-end: 0px;
    }
  }
}
.gat-head {
  width: 100%;
  top: 0;
  z-index: 5;
  box-sizing: border-box;
}

.clearfix:after {
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
  content: '';
}

.navs {
  height: 100%;
  // max-height: 83%;
  background: #f2f5fc;
  // background: #ccc;
  // border: 1xp solid #ccc;
  // box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.05);
  // border: 1px solid #ccc;
  position: fixed;
  top: 80px;
  right: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 40px 10px 10px;
  /* 设置滚动条的样式 */
  &::-webkit-scrollbar {
    width: 5px;
    box-shadow: inset006pxrgba(0, 0, 0, 0.7);
    -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.7);
  }
  /* 滚动槽 */
  &::-webkit-scrollbar-track {
    box-shadow: inset006pxrgba(0, 0, 0, 0.7);
    -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.7);
    border-radius: 5px;
  }
  /* 滚动条滑块 */
  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: rgba(103, 140, 255, 0.5);
    box-shadow: inset006pxrgba(0, 0, 0, 0.7);
    -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.7);
  }
  &::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(103, 140, 255, 0.5);
  }

  &:before {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 2px solid #eaecef;
    background-color: #fff;
    z-index: 10;
    left: 10px;
    top: 48px;
  }
  &:after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 2px solid #eaecef;
    background-color: #fff;
    z-index: 10;
    left: 10px;
    // top: 100%;
    margin-top: 5px;
  }
  .drop {
    list-style: none;
    padding-left: 0;
  }
  span {
    padding-left: 20px;
    cursor: pointer;
    color: #333;
  }
}

.drop li {
  position: relative;
  padding-left: 20px;
  &:before {
    // left: -7px;
    left: 6px;
    top: 0px;
    content: '';
    position: absolute;
    width: 1px;
    height: 120%;
    background-color: #eaecef;
  }
  a {
    font-size: 14px;
    color: #666;
  }
}
.drop li.active {
  &:after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    // background-color: $bgc_btn_primary;
    background-color: $bgc_btn_primary;
    left: 2px;
    top: 55%;
    margin-top: -5px;
  }
  a {
    // color: $bgc_btn_primary;
    // border-color: $bgc_btn_primary;
    color: $bgc_btn_primary;
    border-color: $bgc_btn_primary;
  }
}
.help-right .content {
  padding: 50px 0 150px 0;

  .section-wrap,
  .section {
    margin-bottom: 30px;
    .guide-dom {
      // height: 120px;
      width: 700px;
      height: auto;
      // overflow: hidden;
    }
  }
  .section:last-child {
    min-height: 55vh;
  }
}
.help-left .item {
  a {
    color: #2c3e50;
  }
}
.sec-divide {
  transform: translateY(30px);
}
</style>
